import { render, staticRenderFns } from "./CircledAvatar.vue?vue&type=template&id=1e209aed&scoped=true&"
import script from "./CircledAvatar.vue?vue&type=script&lang=ts&"
export * from "./CircledAvatar.vue?vue&type=script&lang=ts&"
import style0 from "./CircledAvatar.vue?vue&type=style&index=0&id=1e209aed&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e209aed",
  null
  
)

export default component.exports